import { SOGetOrganization } from '../organization/so-get-organization';


export class SOPostRole {

  constructor(
    public name: string,
    public identifier: string,
    public organization: SOGetOrganization = null,
  ) {
  }
  static construct(params: {[key: string]: any}) {
    return new SOPostRole(
      'name' in params ? params.name : null,
      'identifier' in params ? params.identifier : null,
      'organization' in params ? params.organization : null,
    );
  }
}
